import { axiosInstance } from 'api/apiConfig'
import { useQuery } from 'react-query'

const commonSiteList = async (target, params) => {
  const { data } = await axiosInstance.post(`/api/steRtrv/v1.0/${target}`, params)
  return data
}

/**
 * 사이트 목록 조회
 * @param { searchShp, searchSiteId } params
 * @param {*} isInit
 * @returns
 */
export const useCommonSite = (params, isInit) => {
  return useQuery(['commonSiteList', params], () => commonSiteList('list', params), {
    enabled: isInit,
  })
}
